import notificationError from '@/utils/functions/notificationError';
import { useMutation } from 'react-query';
import { getArchive, uploadArchive } from './Archive.service';
import { notification } from 'antd';

export function useArchiveUpload() {
  return useMutation(uploadArchive, {
    onError(error) {
      notificationError(error);
    },
  });
}

export function useArchiveGetArchive() {
  const mutation = useMutation(getArchive, {
    onSuccess() {
      notification.success({
        message: 'Sucesso',
        description: 'Arquivo baixado com sucesso!',
      });
    },
    onError(error) {
      notificationError(error);
    },
  });

  return mutation;
}
